import moment from 'moment'
import * as Yup from 'yup'

const buildSchema = (originalStartDate = null) =>
  Yup.object().shape({
    startDate: Yup.date()
      .nullable()
      .typeError('Data inválida')
      .required()
      .notInPast({
        message: 'A data não pode ser no passado',
        initialValue: originalStartDate,
      }),
    recurrence: Yup.number().min(1, 'Deve ser maior que zero').required(),
    recurrencePeriodType: Yup.string().required(),
    duration: Yup.number()
      .min(1, 'Deve ser maior que zero')
      .required()
      .test(
        'duration-lte-recurrence',
        'O prazo não pode ser maior que a periodicidade',
        function (value) {
          const { recurrence, recurrencePeriodType, durationPeriodType } =
            this.parent
          if (
            !value ||
            !recurrence ||
            !recurrencePeriodType ||
            !durationPeriodType
          )
            return true
          const durationMs = moment
            .duration(Number(value), durationPeriodType)
            .asMilliseconds()
          const recurrenceMs = moment
            .duration(Number(recurrence), recurrencePeriodType)
            .asMilliseconds()
          return durationMs <= recurrenceMs
        },
      ),
    durationPeriodType: Yup.string().required(),
    quizTemplateIds: Yup.array()
      .of(Yup.number())
      .min(1, 'Selecione ao menos um questionário'),
  })

export default buildSchema
